import {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {PublicacaoApi} from "../../apis";
import {ArquivoEditor, Paginacao} from "../../components";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {FaNewspaper} from "react-icons/fa";

export const Publicacao = () => {
  const [carregado, setCarregado] = useState(false);
  const [publicacoes, setPublicacoes] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [paginacaoInfo, setPaginacaoInfo] = useState(null);
  const navigate = useNavigate();
  const {setLoading} = useContext(LoadingContext);
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const location = useLocation();
  const [ordem, setOrdem] = useState('DESC');

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const loadPublicacoes = async () => {
    setLoading(true);
    let search = null;
    let respostaPublicacoes;
    try {
      if (typeof location.state.search !== 'undefined') {
        search = (location.state.search);
      }
    } catch (e) {}
    try {
      if (search !== null) {
        respostaPublicacoes = await PublicacaoApi.getAllAdminSearch(user.uuid, pagina, search);
      } else {
        respostaPublicacoes = await PublicacaoApi.getAllAdmin(user.uuid, pagina, ordem);
      }
      if (!respostaPublicacoes.error) {
        let tempArq = [];
        for (let i = 0; i < respostaPublicacoes.data.length; i++) {
          tempArq.push(respostaPublicacoes.data[i]);
        }
        setPublicacoes(tempArq);
        setPaginacaoInfo(respostaPublicacoes.paginacao);
        setLoading(false);
      } else {
        setLoading(false);
        AddToast({texto:respostaPublicacoes.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto:e, tipo: "erro"});
      setLoading(false);
    }
  }

  useEffect(() => {loadPublicacoes()}, [pagina]);


  if (!carregado) {
    loadPublicacoes();
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Publicações',
        icone: <FaNewspaper size={30}/>
      }
    );
    setCarregado(true);
  }

  useEffect(() => {loadPublicacoes()}, [ordem]);

  const setAsc = () => {
    setOrdem('ASC');
  }

  const setDesc = () => {
    setOrdem('DESC');
  }

  return (
    <div className="publicacao">
        {publicacoes &&
          <div className="painel-itens">
            <div className="botoes">
              <div className="ordenacao">
                <span>Ordenar por:</span>
                <div className={ordem === 'DESC' ? "btn btn-primary" : "btn btn-secondary"} onClick={setDesc}>
                  Mais recentes
                </div>
                <div className={ordem === 'ASC' ? "btn btn-primary" : "btn btn-secondary"} onClick={setAsc}>
                  Mais antigas
                </div>
              </div>
              <div className="btn btn-enviar" onClick={() => navigate('/portalcolaborador/publicacao/edit', {state: {propUuid: 0}})}>
                Adicionar Publicação
              </div>
            </div>
            {publicacoes.map((item, index) =>
              <ArquivoEditor update={loadPublicacoes} item={item} key={index}/>
            )}
            <Paginacao pagina={pagina} setPagina={setPagina} info={paginacaoInfo}/>
          </div>
        }
    </div>
  )
}